<template>
  <div id="app" :key="appKey">
    <router-view/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      appKey: 1
    }
  },
  watch: {
    // // 二级路由路由跳转视图切换
    // '$route': function (newUrl, oldUrl) {
    //   this.appKey = new Date().getTime()
    // }
  }
}
</script>

<style lang="less">
.navMask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}
.myShadowTooltip{
    background: #fff !important;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
    color: #000 !important;
    .info{
        padding: 8px;
        font-size: 12px;
        color: #151B26;
        h5{
            font-weight: 600;
            margin-bottom: 8px;
        }
        dl{
            padding-left: 4px;
            margin-bottom:8px;
            display: flex;
            dt{
                color: #5C5F66;
                width: 100px;
            }
        }
        .details{
            margin-left: 4px;
            border-radius: 6px;
            background-color: #F7F7F9;
            padding: 14px 15px;
            line-height: 2;
            b{
                font-weight: 600;
            }
        }
        &.en{
            dl{
                dt{
                    width: 130px;
                }
            }
        }

    }
}
.myShadowTooltip[x-placement^="top"] .popper__arrow {
    border-top-color: #fff !important;
    filter: box-shadow(0px 3px 10px 1px rgba(0, 0, 0, 0.1));
}
  
.myShadowTooltip[x-placement^="top"] .popper__arrow:after {
    border-top-color:#fff !important;
}
  
.myShadowTooltip[x-placement^="bottom"] .popper__arrow { 
    border-bottom-color: #fff !important;
    filter: box-shadow(0px 3px 10px 1px rgba(0, 0, 0, 0.1));
}
  
.myShadowTooltip[x-placement^="bottom"] .popper__arrow:after {
    border-bottom-color:#fff !important;
}
</style>